import icon from './icon';
import { jsx as _jsx } from "react/jsx-runtime";
const Icon = icon("0 0 20 17", "Circle Check", /*#__PURE__*/_jsx("path", {
  d: "M10 .5a8 8 0 1 0 8 8 8 8 0 0 0-8-8Zm0 15a7 7 0 1 1 7-7 7 7 0 0 1-7 7Z"
}), /*#__PURE__*/_jsx("path", {
  d: "M8.49 10.72 6.01 8.24l-.7.71 3.18 3.18 6.2-6.2-.71-.71-5.49 5.5z"
}));
if (process.env.NODE_ENV !== 'production') Icon.displayName = "IconCircleCheck";
export default Icon;